import React from 'react';
import { Icon } from '../../foundations';

import {
  CircularText,
  CircularSquare,
  CircularIcon,
} from './CircleIcon.styles';
import { CircleIconProps } from './CircleIcon.types';

/**
 * Chat circle icon component designed for user identification in chat contexts.
 *
 * Either 1-2 characters taken from the name, or a provided image, depending on the type prop.
 *
 * Based on core figma designs
 * @see https://www.figma.com/file/zYke5qihweC8yQSpXpcRO2/%F0%9F%93%9000-OM-CORE-Library?node-id=4203%3A14533
 */
const CircleIcon = (props: CircleIconProps) => {
  const { type, icon = '' } = props;

  const getIconLetters = (name: string) => {
    if (!/[A-Z]/.exec(name)) {
      return name
        ?.split(' ')
        .map(word => word[0])
        .join('')
        .substring(0, 2)
        .toLocaleUpperCase();
    }

    return name
      ?.split('')
      .filter(a => a.match(/[A-Z]/))
      .join('')
      .substring(0, 2);
  };

  switch (type) {
    case 'image':
      return <CircularSquare {...props} />;

    case 'icon':
      return (
        <CircularIcon {...props}>
          {icon && <Icon name={icon} inheritFill />}
        </CircularIcon>
      );

    case 'text':
    default:
      return (
        <CircularText {...props}>{getIconLetters(props.name!)}</CircularText>
      );
  }
};

export default CircleIcon;
